import React from 'react'
import {CI2} from '../../utils/calendar'
import SupplierElement from '../debit/rowelements/supplierelement'
import {getToken} from '../../storage'
import {NotificationManager} from 'react-notifications'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import {Loader} from '../../utils/misc'
import moment from 'moment'

export default class Generalnote extends React.Component {

  constructor(props){
    super(props)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.submit = this.submit.bind(this)
    this.getGeneralNote = this.getGeneralNote.bind(this)
    this.handleSupplierChange = this.handleSupplierChange.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.deleteGeneralnote = this.deleteGeneralnote.bind(this)
    this.state = { loading:true, generalnote:{ totalPrice:"", date:moment(new Date()).format(), txn_mode:"cash", reference:"", notes:"", is_generalnote:true, pretnitem_set:[] }}
  }

  handleDateChange(da) {
    this.modifyItemState('date', da)
  }
  handleInputChange(e) {
    this.modifyItemState(e.target.name, e.target.value)
  }
  handleSupplierChange(supplier) {
    this.modifyItemState('supplier', supplier)
  }


    modifyItemState(key, value) {
      this.setState({errors: undefined})
          let currentRetn = this.state.generalnote
          currentRetn[key] = value
          this.setState({
            generalnote:currentRetn
         });
    }


  componentDidMount() {

    let params = this.props.match.params
    if(typeof params.generalnote_id !== "undefined") {
      this.setState({mode:'edit'})
      document.title = "Edit General Debit Note " + this.props.match.params.generalnote_id
      this.getGeneralNote(this.props.match.params.generalnote_id).then((response)=>{
        if(response.status===200) {
          console.log(response.data.pretn);
          this.setState({generalnote: response.data.pretn, loading:false})

        }
      }).catch((err)=>{
        this.setState({loading:false})
      })
    }
    else {
        document.title = "Create General Debit Note "
        this.setState({loading:false})
    }
  }

  getGeneralNote(pretn_id) {
    return axios({
      url: '/get_pretn/?serial='+pretn_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  deleteGeneralnote() {
  let confirmation = window.confirm('You are about to delete this..!')
  if(confirmation) {

    axios({
      url: '/delete_pretn/',
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state.generalnote
    }).then((response)=> {
      this.setState({'submitting':false})
      if(response.status === 200) {
          NotificationManager.success("Deleted Debit Note successfully")
        setTimeout(()=>{
          this.props.history.push("/debit_notes/")
        }, 700)
      }
    }).catch((err)=> {
      console.log(err);

    })
  }

  }



    submit(e) {
      this.setState({'submitting':true})

      let apiurl
      if(this.state.mode ==="edit") {
        apiurl  = "/update_pretn/"
      }
      else {
        apiurl  = "/create_new_pretn/"
      }

      console.log(this.state.generalnote);

      axios({
        url: apiurl,
        method: 'post',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          },
          post: {
            'Content-Type': 'multipart/form-data;'
          }
        },
        data: this.state.generalnote
      }).then((response)=> {
        if(response.status === 200) {
          this.setState({'submitting':false})
          if(this.state.mode === "edit") {
              NotificationManager.success("Updated Debit Note successfully")
          }
          else {
            NotificationManager.success("Created Debit Note successfully")
          }

          setTimeout(()=>{
            this.props.history.push("/debit_notes/")
          }, 700)

        }
      }).catch((err)=> {
        console.log(err);
        this.setState({'submitting':false})
        if(typeof err.response !== "undefined" && err.response.data !== "undefined") {
          this.setState({errors: err.response.data.errors})
        }
      })
    }



  render() {

    let generalnote = this.state.generalnote

    let submitButton = <button className="btn btn-success" onClick={this.submit}>Save</button>

    if(this.state.submitting) {
      submitButton = <button className="btn btn-success" disabled>Saving..</button>
    }

      let supplier = <SupplierElement pretn={generalnote} onAddCallback={this.handleSupplierChange} />

      let amountError
      if(typeof this.state.errors !== "undefined") {

         let errors = this.state.errors
         if(typeof errors.totalPrice !== "undefined") {
           amountError = <p className="text-danger">{errors.totalPrice[0]}</p>
         }
      }

    let form = <div className="form-horizontal">
          <div className="form-group">
            <div className="col-sm-2">
            Supplier
            </div>
            <div className="col-sm-10">
            {supplier}
            </div>

          </div>


          <div className="form-group">
          <div className="col-sm-2">
          Amount (&#8377;)
          </div>
          <div className="col-sm-10">
          <input  type="text" name="totalPrice" value={generalnote.totalPrice} onChange={this.handleInputChange} className="form-control input-sm" required />
          {amountError}
          </div>
          </div>

          <div className="form-group">
          <div className="col-sm-2">
          Date

          </div>

          <div className="col-sm-10">
          <CI2 applyDate={this.handleDateChange} date={generalnote.date} />
          </div>
          </div>

          <div className="form-group">

          <div className="col-sm-2">
          Payment Mode
          </div>
            <div className="col-sm-10">
            <select name="txn_mode" value={generalnote.txn_mode} className="form-control input-sm" onChange={this.handleInputChange}>
              <option value="cash" >CASH</option>
              <option value="card">CARD</option>
              <option value="cheque">CHEQUE</option>
              <option value="banktransfer">BANK TRANSFER</option>
              <option value="others">Others</option>
            </select>
            </div>
          </div>

          <div className="form-group">
          <div className="col-sm-2">
          Reference
          </div>

          <div className="col-sm-10">
          <input  type="text" name="reference" value={generalnote.reference} onChange={this.handleInputChange} className="form-control input-sm" />
          </div>
          </div>

          <div className="form-group">
          <div className="col-sm-2">
          Notes
          </div>
           <div className="col-sm-10">
          <textarea name="notes" className="form-control input-sm" value={generalnote.notes} onChange={this.handleInputChange}></textarea>
           </div>
          </div>

      </div>



      let pageHeader
      let deleteRetnBtn
      if(!this.state.loading) {
        if(this.state.mode === "edit") {
          pageHeader = <h3>{"Edit General Debit Note  #" + generalnote.serial}</h3>
          deleteRetnBtn = <button className="btn btn-sm btn-danger" onClick={this.deleteGeneralnote}>Delete Debit Note</button>
        }
        else {
          pageHeader =  <h3>Create New Debit Note</h3>
        }

        return <div className="container-fluid">
        <section className="medium">
              {pageHeader}
              <ul className="list-inline">
                <li className="pull-right">{deleteRetnBtn}</li>
              </ul>
        </section>
                  <div className="row">
                  <div className="col-md-6">
                  {form}
                  <div className="form-action-group text-right">
                  {submitButton}
                  </div>
                  </div>
                  </div>
    </div>
      }
      else {
        return <div>
            <Loader />
        </div>
      }


  }
}



// WEBPACK FOOTER //
// ./src/components/generalnote/addgeneraldebit.js